export const environment = {
  envName: 'lcl',
  api: {
    protocol: undefined,
    hostname: 'www.api.dev.boxhub.df-tech.cz',
    port: '443',
  },
  inactivityLimitMs: 30_000,
  thankYouWaitLimitMs: 5_000,
  thankYouServiceWaitLimitMs: 10_000,
};
